import { render } from "./ListadoLeads.vue?vue&type=template&id=8282b4a2"
import script from "./ListadoLeads.vue?vue&type=script&lang=js"
export * from "./ListadoLeads.vue?vue&type=script&lang=js"

import "./ListadoLeads.vue?vue&type=style&index=0&id=8282b4a2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__